import concat from 'lodash/concat'
import find from 'lodash/find'
import forEach from 'lodash/forEach'
import get from 'lodash/get'
import map from 'lodash/map'
import moment from 'moment'

export const formatPurchasEvent = (rooms, promoCode) => {
  const dataLayer = window.dataLayer || []
  forEach(rooms, room => {
    const startDate = get(room, 'roomStays[0].timeSpan.start')
    const endDate = get(room, 'roomStays[0].timeSpan.end')
    const roomPurchaseItem = [{
      hotel_name: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
      hotel_code: get(room, 'roomStays[0].basicPropertyInfo.hotelCode'),
      item_name: `${get(room, 'roomStays[0].roomTypes[0].roomDescription.name')} - ${get(room, 'roomStays[0].ratePlans[0].ratePlanName')}`,
      item_id: `${get(room, 'roomStays[0].roomTypes[0].roomTypeCode')}-${get(room, 'roomStays[0].basicPropertyInfo.hotelCode')}`,
      price: get(room, 'roomStays[0].roomTypes[0].viewExtensions.roomRates[0].rates[0].base.amountBeforeTax'),
      item_brand: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
      item_category: 'Rooms',
      item_variant: get(room, 'roomStays[0].ratePlans[0].ratePlanName'),
      quantity: moment(endDate).diff(moment(startDate), 'days'),
    }]
    const servicePurchaseItems = map(get(room, 'services', []), item => ({
      hotel_name: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
      hotel_code: get(room, 'roomStays[0].basicPropertyInfo.hotelCode'),
      item_name: get(find(get(item, 'serviceDetails.comments'), comment => get(comment, 'name') === 'Title'), 'text'),
      item_id: get(item, 'serviceInventoryCode'),
      price: get(item, 'price[0].base.amountBeforeTax'),
      item_brand: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
      item_category: 'Add-on',
      item_variant: '',
      quantity: get(item, 'quantity'),
    }))
    const totalTaxes = get(room, 'resGlobalInfo.total.amountAfterTax') - get(room, 'resGlobalInfo.total.amountBeforeTax')
    const purchaseEvent = {
      event: 'ga4_purchase',
      hotel_name: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
      hotel_code: get(room, 'roomStays[0].basicPropertyInfo.hotelCode'),
      ecommerce: {
        currency: get(room, 'roomStays[0].total.currencyCode'),
        value: get(room, 'roomStays[0].total.amountAfterTax'),
        tax: totalTaxes,
        shipping: 0,
        affiliation: get(room, 'roomStays[0].basicPropertyInfo.hotelName'),
        transaction_id: get(room, 'id'),
        coupon: promoCode || '',
        items: concat(roomPurchaseItem, servicePurchaseItems),
      }
    }
    dataLayer.push(purchaseEvent)
  })
}


// WEBPACK FOOTER //
// ./src/utilities/analytics/purchaseEvent.js